import React from "react";

export const AdvisoryTextComponent = ({
  disclaimer,
  advisory,
  staticAdvisory,
}) => {
  return (
    <div
      className="text-center mt-4 p-3 rounded shadow-sm mb-4 flex flex-column gap-4"
      style={{ backgroundColor: "#ebebeb" }}
    >
      <h5 className="mb-3" style={{ fontWeight: 600, color: "#333" }}>
        Advisory Recommendation
      </h5>

      <div className=" d-lg-block d-md-block d-none">
        <span
          className="text-white "
          style={{
            backgroundColor: "#28a745",
            fontSize: "14px",
            padding: "12px 20px",
            borderRadius: "8px",
          }}
        >
          {staticAdvisory}
        </span>
      </div>

      <div
        className="text-white w-full d-lg-none d-md-none d-block"
        style={{
          backgroundColor: "#28a745",
          fontSize: "14px",
          padding: "12px 20px",
          borderRadius: "8px",
        }}
      >
        {staticAdvisory}
      </div>

      <p
        className="text-muted mb-3 mt-4 fst-italic"
        style={{ fontSize: "12px" }}
      >
        <strong>Disclaimer :</strong>{" "}
        {disclaimer
          ? disclaimer
          : "This is a probabilistic scenario based on current ACS and hence may vary with the ground situations or in the scenario of adding further datasets."}
      </p>
    </div>
  );
};
